<template>
    <div class="registration-form">
        <v-form @submit.prevent v-model="valid">
            <v-container class="ma-0 pa-0">
                <v-row>
                    <v-col cols =6>
                        <v-btn
                            class="authorization-btn"
                            variant="text"
                            height="52"
                            width="204"
                            @click="changeForm()">
                            Вход
                        </v-btn>
                    </v-col>
                    <v-col cols =6>
                        <v-btn
                            class="authorization-disabled-btn authorization-btn"
                            variant="flat"
                            color="#001055"
                            height="52"
                            width="204">
                            Регистрация
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-10 registration-form-text-field"
                                color="#0075AA"
                                label="Введите фамилию"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="surname"
                                :rules=[surname_rules]>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-5 registration-form-text-field"
                                color="#0075AA"
                                label="Введите имя"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="name"
                                :rules=[name_rules]>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-5 registration-form-text-field"
                                color="#0075AA"
                                label="Введите отчество"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="patronymic">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-5 registration-form-text-field"
                                color="#0075AA"
                                label="Введите mail"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="email"
                                :rules="[email_rules]">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-5 registration-form-text-field"
                                color="#0075AA"
                                label="Введите пароль"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="password"
                                :rules="[password_rules]"
                                type="password">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="ml-12 mr-12 mt-n2 d-flex justify-start login-form-error-msg">
                            {{ register_msg }}
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mt-12 ml-12 mr-12 d-flex justify-start">
                            <div>
                                <v-btn
                                    variant="flat"
                                    color="#0075AA"
                                    width="312"
                                    height="48"
                                    :disabled="btn_disabled"
                                    @click="register">
                                    Регистрация
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>
<script>

import { useAuthStore } from '@/store/auth'

export default {
    name: 'LoginForm',
    data() {
        // let ru_letters = [
        // 'А',
        // 'Б',
        // 'В',
        // 'Г',
        // 'Д',
        // 'Е',
        // 'Ж',
        // 'З',
        // 'И',
        // 'Й',
        // 'К',
        // 'Л',
        // 'М',
        // 'Н',
        // 'О',
        // 'П',
        // 'Р',
        // 'С',
        // 'Т',
        // 'У',
        // 'Ф',
        // 'Х',
        // 'Ц',
        // 'Ч',
        // 'Ш',
        // 'Щ',
        // 'Э',
        // 'Ю',
        // 'Я'
        // ]
        return {
            email: '',
            password: '',
            surname: '',
            name: '',
            msg: '',
            patronymic: '',
            email_rules: (value) => {
                if (!value)
                    return "Необходимо ввести почту";
                if (!/.+@.+\.\w{2,4}/.test(value))
                    return 'Недействительная электронная почта';
                return true
            },
            password_rules: (value) => {
                if (!value)
                    return "Необходимо ввести пароль";
                if (value.length >20)
                    return "Пароль не должен быть длиннее 20 символов";
                if (value.length < 6)
                    return "Пароль не должен быть короче 6 символов";
                if (value.indexOf(" ") >0)
                    return "Пароль не должен содержать пробелы";
                return true;
            },
            surname_rules: (value) => {
                if (!value)
                    return "Необходимо указать фамилию";
                // for (let _letter of value){
                //     if (_letter == 'Ё'){
                //         return "Используйте букву Е вместо Ё"
                //     }
                // }
                // for (let _letter of value){
                //     if (!ru_letters.includes(_letter)){
                //         return "Необходимо использовать лишь русские буквы"
                //     }
                // }
            },
            name_rules: (value) => {
                if (!value)
                    return "Необходимо указать имя";
                // for (let _letter of value){
                //     if (_letter == 'Ё'){
                //         return "Используйте букву Е вместо Ё"
                //     }
                // }
                // for (let _letter of value){
                //     if (!ru_letters.includes(_letter)){
                //         return "Необходимо использовать лишь русские буквы"
                //     }
                // }
            },
            // patronymic_rules: (value) => {
            //     // for (let _letter of value){
            //     //     if (_letter == 'Ё'){
            //     //         return "Используйте букву Е вместо Ё"
            //     //     }
            //     // }
            //     // for (let _letter of value){
            //     //     if (!ru_letters.includes(_letter)){
            //     //         return "Необходимо использовать лишь русские буквы"
            //     //     }
            //     // }
            //     return true
            // },
            valid: false 
        }
    },
    computed:{
        register_msg(){
            const authStore = useAuthStore()
            return authStore.register_msg
        },
        btn_disabled() {
            const authStore = useAuthStore()
            if (authStore.register_msg == 'Пользователь успешно создан'){
                return true
            }
            return false
        },
    },
    mounted() {
        const authStore = useAuthStore()
        authStore.register_msg = ''
    },
    methods: {
        changeForm(){
            this.$emit('changeForm')
        },
        register(){
            if (!this.valid){
                return
            }
            const authStore = useAuthStore()
            authStore.register({
                'email': this.email,
                'password': this.password,
                'surname': this.surname,
                'name': this.name,
                'patronymic': this.patronymic
            })
        }
    }
}

</script>